import styled from "styled-components";

export const StyledErrorBoundary = styled.div<{
    theme: "light" | "dark";
}>`
    max-width: 100dvw;
    box-sizing: border-box;
    background-color: ${({ theme }) => (theme === "dark" ? "#000" : "#fff")};
    color: ${({ theme }) => (theme === "dark" ? "#fff" : "#000")};
    min-height: 100dvh;
    max-height: 100dvh;
    max-width: 100dvw;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    font-family: "Inter", sans-serif;
    padding: 16px;
`;

export const StyledErrorBoundaryTop = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`;

export const StyledErrorBoundaryBottom = styled.div<{
    theme: "light" | "dark";
}>`
    display: flex;
    flex-direction: column;
    align-items: center;

    button {
        &:disabled {
            background-color: ${({ theme }) =>
                theme === "dark" ? "#d3d3d4" : "#4F4F4F"};
        }
    }
`;

export const StyledErrorBoundaryImage = styled.img`
    height: 184px;
    width: 236px;
`;

export const StyledErrorBoundaryTitle = styled.h1`
    font-family: "Inter", sans-serif;
    margin-top: 40px;
    font-size: 20px;
    font-weight: 500;
    line-height: 26px;
    text-align: center;
`;

export const StyledErrorBoundaryInfoBlock = styled.div`
    margin-top: 20px;
    display: flex;
    gap: 16px;
    align-items: center;
`;

export const StyledErrorBoundaryInfoText = styled.p<{
    theme: "light" | "dark";
}>`
    font-size: 16px;
    font-weight: 500;
    line-height: 19px;
    max-width: 80dvw;
    overflow: auto;
    color: ${({ theme }) => (theme === "dark" ? "#d3d3d4" : "#4F4F4F")};
    overflow: auto;
    max-height: 20dvh;
`;

export const StyledErrorHeader = styled.div`
    display: flex;
    flex-direction: column;
`;

export const StyledErrorVersionText = styled.p<{
    theme: "light" | "dark";
}>`
    font-size: 16px;
    font-weight: 500;
    line-height: 19px;
    text-align: center;
    color: ${({ theme }) => (theme === "dark" ? "#d3d3d4" : "#4F4F4F")};
`;

export const StyledErrorBoundaryDetails = styled.details`
    white-space: pre-wrap;
    text-align: center;
    max-width: 85dvw;
    overflow: auto;
    max-height: 14dvh;
    margin-top: 5px;
`;

export const StyledErrorControllers = styled.div`
    padding: 0 16px;
    margin-top: 10px;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
`;
